import { z } from '@hono/zod-openapi'
import { usersTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertUser = z.infer<typeof zInsertUser>
export type SelectUser = z.infer<typeof zSelectUser>
export type UpdateUser = z.infer<typeof zUpdateUser>
export type QueryUsers = z.infer<typeof zQueryUsers>
export type ColumnsOfUsersTable = keyof typeof usersTable._.columns

export const zSelectUser = createSelectSchema(usersTable)
export const zInsertUser = createInsertSchema(usersTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateUser = zInsertUser.partial()
export const zQueryUsers = zInsertUser
    .extend({
        id: z.string(),
        ids: z.string().array(),
        status: z.enum(['active', 'suspended']).optional(),
        companyType: z.enum(['vendor', 'client']).optional(),
        isOwner: z
            .preprocess((val) => {
                if (val === 'true' || val === true) return true
                if (val === 'false' || val === false) return false
                return undefined
            }, z.boolean())
            .optional(),
    })
    .extend(zCommonQuery.shape)
    .partial()
